var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PrimaryNavigationItem from "./PrimaryNavigationItem";
import SecondaryNavigationItem from "./SecondaryNavigationItem";
import Logo from "./Logo";
import { classNames } from "../Util";
var NavigationItems = function (_a) {
    var appName = _a.appName, logo = _a.logo, primaryNavigation = _a.primaryNavigation, secondaryNavigation = _a.secondaryNavigation, secondaryNavigationTitle = _a.secondaryNavigationTitle, _b = _a.mobile, mobile = _b === void 0 ? false : _b;
    return (_jsxs(_Fragment, { children: [_jsx(Logo, { appName: appName, logo: logo }), _jsxs("nav", __assign({ className: classNames("flex flex-col justify-between h-full bg-transparent", mobile
                    ? "mt-5 space-y-8 px-2"
                    : "mt-5 flex-1 space-y-8 px-2") }, { children: [_jsx("div", __assign({ className: !mobile ? "space-y-1" : "" }, { children: primaryNavigation.map(function (item) { return (_jsx(PrimaryNavigationItem, { item: item }, item.name)); }) })), _jsxs("div", __assign({ className: "space-y-1" }, { children: [_jsx("h3", __assign({ className: "px-3 text-sm font-medium text-blue-100 text-opacity-60", id: "secondary-nav" }, { children: secondaryNavigationTitle })), _jsx("div", __assign({ className: "space-y-1", role: "group", "aria-labelledby": "secondary-nav" }, { children: secondaryNavigation.map(function (item) { return (_jsx(SecondaryNavigationItem, { item: item }, item.name)); }) }))] }))] }))] }));
};
export default NavigationItems;
